import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { AvailableDaysBody, AvailableDaysResponse } from '@utils/interfaces';
import { useEffect, useState } from 'react';
import { STATUS_ALERT } from '@components/CalendarPage/CalendarPage.interface';
import { useOBQuery } from '@hooks/useOBQuery';

const useGetCalendarDays = ({
  practiceIdValue,
  appointmentTypeValue,
  insuranceSelectedValue,
  locationIdValue,
  reservationStatusValue,
  practitionerIdValue,
}: AvailableDaysBody) => {
  const [practiceId, setPracticeId] = useState(practiceIdValue);
  const [appointmentType, setAppointmentType] = useState(appointmentTypeValue);
  const [insuranceSelected, setInsuranceSelected] = useState(
    insuranceSelectedValue,
  );
  const [locationId, setLocationId] = useState(locationIdValue);
  const [reservationStatus, setReservationStatus] = useState(
    reservationStatusValue,
  );
  const [practitionerId, setPractitionerId] = useState(practitionerIdValue);

  const url = useApiUrl(
    OBRoutes.AvailDays,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )
    ?.replace('##practiceId', practiceId)
    ?.concat(
      `?appointmentType=${appointmentType}&insuranceSelected=${insuranceSelected}&locationId=${locationId}`.concat(
        practitionerId ? `&practitionerId=${practitionerId}` : '',
      ),
    );

  useEffect(() => {
    setPracticeId(practiceIdValue);
    setAppointmentType(appointmentTypeValue);
    setInsuranceSelected(insuranceSelectedValue);
    setLocationId(locationIdValue);
    setReservationStatus(reservationStatusValue);
    if (practitionerIdValue) setPractitionerId(practitionerIdValue);
  }, [
    practiceIdValue,
    appointmentTypeValue,
    insuranceSelectedValue,
    locationIdValue,
    reservationStatusValue,
    practitionerIdValue,
  ]);

  return useOBQuery<AvailableDaysResponse>(url, {
    enabled: !!(
      practiceId &&
      appointmentType &&
      (insuranceSelected || insuranceSelected === '') &&
      locationId &&
      (reservationStatus === STATUS_ALERT.HAPPY_FLOW ||
        reservationStatus === STATUS_ALERT.GET_DAYS_TO_VERIFY)
    ),
    queryKey: [
      practiceId,
      appointmentType,
      insuranceSelected,
      locationId,
      practitionerId,
    ],
  });
};

export default useGetCalendarDays;
